export interface PaymentAccount {
  agencyUserGroupId: string;
  creditLimit: number;
  windowDays: number;
  enabled: boolean;
}

/** What the payment account dialog closes with once the configuration is deleted. */
export interface PaymentAccountDeleted {
  deleted: true;
}

export function isPaymentAccountDeleted(
  result: PaymentAccount | PaymentAccountDeleted | null | undefined
): result is PaymentAccountDeleted {
  return !!result && 'deleted' in result && result.deleted === true;
}
